module.exports = __webpack_public_path__ + "static/media/add_circle_outline.56eb3d2c.svg";